<template>
    <PageLoading v-if="isLoading" />

    <div
        v-else
        class="main-wrap partners-single-page">

        <div class="partner-header">
            <div
                class="bg-img"
                :style="{'background-image': 'url(' + partner.picture + ')'}">
            </div>

            <div class="partner-header-inner">
                <div class="partner-logo">
                    <img
                        :src="partner.logo"
                        alt=""
                    />
                </div>

                <div class="partner-description">
                    <div class="partner-info">
                        <p v-html="JSONParseTranslations(partner.description, locale.key)"></p>

                        <p>
                            <a
                                v-if="partner.url"
                                :href="partner.url"
                                class="text-subtitle1"
                                target="_blank">

                                <u>{{ $t('partners.institutional_website') }}</u>
                            </a>
                        </p>
                    </div>

                    <q-icon
                        v-scroll-to="'#anchor'"
                        class="scroll-to-btn"
                        name="arrow_back_ios">
                    </q-icon>
                </div>
            </div>
        </div>

        <h2
            id="anchor"
            class="text-h5">

            {{ $t('partners.partner_training_offer', { partner:JSONParseTranslations(partner.title, locale.key) }) }}
        </h2>

        <div class="partner-courses">
            <h5
                v-if="!areas.length"
                class="text-subtitle1">

                {{ $t('partners.there_arent_areas_for_this_partner') }}
            </h5>

            <template
                v-for="(area, index) in areas"
                v-else>

                <div :key="index">
                    <router-link
                        :to="{
                            name: 'Courses',
                            params: {
                                areaId: area.id,
                                partnerId: partner.id,
                            },
                        }">

                        <h4  class="text-h5">{{ JSONParseTranslations(area.title,locale.key) }}</h4>
                    </router-link>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import translate from '@/local-shared/mixins/translate'
import PageLoading from '@/components/PageLoading'
import partnersService from '@/services/modules/partners'
import picturesService from '@/services/pictures'
import encoders from '@/helpers/encoders'
import store from '@/store'

const loadingKeys = {
    fetchingPartner: 'fetching-partner'
}

export default {
    name: 'PartnersDetails',

    components: {
        PageLoading
    },

    mixins: [translate],

    data() {
        return {
            areas: [],
            partner: {},
        }
    },

    computed: {
        isLoading() {
            return this.isFetchingPartner || this.isFetchingPartnerAreas
        },

        isFetchingPartner() {
            return !!this.loadings.filter(
                (loading) => loading.key === loadingKeys.fetchingPartner
            ).length
        },

        locale() {
            return store.getters['locale/currentLocale']
        }
    },

    async created() {
        await this.fetchPartner()
    },

    methods: {
        async fetchPartner() {
            this.loadingAdd(loadingKeys.fetchingPartner)

            let parameters = {
                filter: {
                    id: this.$route.params.partnerId,
                    active: true
                },

                relations: {
                    partnerAreas: {
                        filter: {
                        areasWithPublishedCourses : true
                        }
                    }
                }
            }

            let response = await partnersService.partners.retrieve(parameters)

            if (response.status === 200) {
                this.partner = response.data.results[0]

                if (this.partner.logo_picture_id) {
                    this.partner.logo = await this.fetchImage(
                        this.partner.logo_picture_id
                    )
                }

                if (this.partner.partner_picture_id) {
                    this.partner.picture = await this.fetchImage(
                        this.partner.partner_picture_id
                    )
                }

                this.areas = response.data.results[0].partners_area
            } else {
                this.$q.notify({
                    type: 'negative',
                    message: this.$t('notify.error_occurred', { message: response.data.message }),
                })
            }

            this.loadingRemove(loadingKeys.fetchingPartner)
        },

        async fetchImage(pictureId) {
            let imageResponse = await picturesService.retrieveById(pictureId)

            if (imageResponse.status === 200) {
                return encoders.arrayBufferToBase64(imageResponse)
            } else {
                return '' //TODO: add a default image
            }
        }
    }
}
</script>